export default {
    ADMIN_LOGIN:"ADMIN_LOGIN",
    ADMIN_LOGOUT:"ADMIN_LOGOUT",
    ADMIN_GET_UPDATE_DATA:"ADMIN_GET_UPDATE_DATA",
    ADMIN_GET_PUSH_NOTIFICATIONS: "ADMIN_GET_PUSH_NOTIFICATIONS",
}